import { Link } from "react-router-dom";
import styled, { keyframes } from 'styled-components';


const cloudFloat = keyframes`
    0% {
        transform: translateX(540px);
        opacity: 0;
    }
    10% {
        opacity: 0.9;
    }
    90% {
        opacity: 0.9;
    }
    100% {
        transform: translateX(-200px);
        opacity: 0;
    }
`;

const beamRotate = keyframes`
    0% { transform: rotate(-12deg); }
    100% { transform: rotate(12deg); }
`

const Cloud = styled.img`
    width: 100%;
    max-width: 578px;
    position: absolute;
    left: 0;
    bottom: 74px;
    animation: ${cloudFloat} 30s linear infinite;

    @media(max-width : 1024px){
            max-width : 100.0000vw;
            bottom: 12.8906vw
        }

    @media(max-width : 520px){
        max-width: 111.1538vw;
        bottom: 14.2308vw;
    }
`;

const Beam = styled.img`
    width: 100%;
    max-width: 489px;
    position: absolute;
    right: 52px;
    top: 4px;
    transform-origin: right center;
    z-index: -1;
    animation: ${beamRotate} 6s ease-in-out infinite alternate;

    @media(max-width : 1024px){
        max-width : 100.0000vw;
        right: 9.2773vw;
        top: 0.3906vw;
    }

    @media(max-width : 520px){
        max-width: 94.0385vw;
        right: 10.0000vw;
        top: 0.7692vw;
    }
`

export default function NotFound(){
    return(
        <div className="notFoundLightHouse">
            <div className="notFoundLightHouse_inner">
                <div className="notFoundLightHouse_content">
                    <div className="notFoundLigh_textbox">
                        <h5>404 ERROR</h5>
                        <p>
                            이 페이지를 표시할 수 없습니다.<br/>
                            나중에 다시 시도하세요.
                        </p>
                        <Link to="/lightHouseImg" className="go_home">홈으로 돌아가기</Link>
                    </div>
                </div>

                <div className='lightHouseIllust'>
                    <div className='lightHouseIllust_inner'>
                        <Cloud src={process.env.PUBLIC_URL + '/lightHouseImg/cloud.png'} alt='cloud'/>
                        <img src={process.env.PUBLIC_URL + '/lightHouseImg/lightHouse.png'} alt='Light House' className='lightHouse' />
                        <Beam src={process.env.PUBLIC_URL + '/lightHouseImg/beam.png'} alt='beam'/>
                    </div>
                </div>

            </div>
        </div>
    )
}